<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Configurações — Ausentes
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  listar
        |  e
        strong  cadastrar
        |  substituições de fiscais ausentes em
        strong  Configurações → Usuários → Ausentes
        | .

      .toast.toast-primary
        | Exige
        strong  Ausentes → Listar
        | . Para incluir ou editar, use
        strong  Ausentes → Criar
        |  e
        strong  Ausentes → Alterar
        | .

      h5.h5 1. Abrir Ausentes
      ol
        li No menu lateral, clique em
          strong  Configurações
          | .
        li Expanda
          strong  Usuários
          |  e clique em
          strong  Ausentes
          | .

      h5.h5 2. Filtros e listagem
      p
        | Os filtros padrão são
        strong  Início maior ou igual a
        | ,
        strong  Fim menor ou igual a
        | ,
        strong  Ausente
        |  e
        strong  Substituto
        |  (seletores de fiscal). Use a engrenagem de filtros para habilitar ou desabilitar campos.
      figure.manual-figure
        img(:src="imgLista" alt="Listagem de ausentes")
      ol
        li Aplique o filtro (ícone de funil) ou
          strong  Imprimir
          |  a lista.
        li A tabela mostra ausente, substituto,
          strong  Tipo
          |  (Férias, Licença, Atestado médico, Outros),
          strong  Inicia em
          |  e
          strong  Termina em
          | .
        li Em cada linha, clique em
          strong  Alterar
          |  para editar.

      h5.h5 3. Novo ou editar ausência
      ol
        li Clique em
          strong  Novo
          |  para cadastrar, ou
          strong  Alterar
          |  na linha.
      figure.manual-figure
        img(:src="imgForm" alt="Formulário de ausência")
      ol
        li Selecione
          strong  Ausente
          |  e
          strong  Substituto
          | .
        li Escolha o
          strong  Tipo
          |  e as datas
          strong  Inicia em
          |  /
          strong  Termina em
          | .
        li Clique em
          strong  Salvar
          | . O modal fecha e a lista atualiza.

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgLista: require("@/assets/manuais/37-config-ausentes-lista.png"),
      imgForm: require("@/assets/manuais/37a-config-ausentes-form.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
